import { IBubbleHandler, BubbleType, Bubble } from 'js/bubbleCore/bubbles/types';
import { handler as regularHandler } from 'js/bubbleCore/bubbles/cores/RegularCore';
import { handler as fireHandler } from 'js/bubbleCore/bubbles/cores/FireCore';

const map: {[Key in BubbleType]: IBubbleHandler<Key>}  = {
  [BubbleType.Regular]: regularHandler,
  [BubbleType.Fire]: fireHandler,
};

export function getBubbleHandler<T extends BubbleType>(bubble: Bubble<T>): IBubbleHandler<T> {
  // @ts-ignore
  return map[bubble.core.type];
}